// extracted by mini-css-extract-plugin
export var logosWrapper = "Logos-module--logosWrapper--951c7";
export var logo = "Logos-module--logo--b5920";